import React from 'react';
import './Preloader.css'

const PreloaderNewTask = () => {
    return (
        <div className="preloader_block">
            <span className="loader"></span>
        </div>
    );
};

export default PreloaderNewTask;